const state = {
    sendListConfirmMonetization: [],
    postConfirmMonetization:null,
    listStartMonetization:[],
    monetizationList:[],
    sendEmail: null,
    emailSend: null,
    loading: false,
    reports: [],
    jobStatus: null,
};

export default state;